import React, { useEffect, useState } from "react";

function initials(name) {
  const m = (name || "").match(/\b\w/g) || [];
  return m.slice(0, 2).join("").toUpperCase() || "??";
}

// Avatar com fallback: se a imagem falhar ao carregar (ex.: 404), mostra as
// iniciais em vez do "alt" quebrado. Reseta o erro quando o src muda.
export default function Avatar({
  src,
  name,
  className = "h-9 w-9",
  textClassName = "text-sm",
}) {
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [src]);

  if (src && !broken) {
    return (
      <img
        src={src}
        alt={name || ""}
        onError={() => setBroken(true)}
        className={`${className} rounded-full object-cover`}
      />
    );
  }

  return (
    <span
      className={`${className} ${textClassName} inline-flex items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-700 font-semibold text-white`}
    >
      {initials(name)}
    </span>
  );
}
